import styled from "styled-components";

export const Figure = styled.figure`
  margin-bottom: 0;
  & > span {
    height: 100% !important;
    width: 100% !important;
  }

  & > picture {
    & > span {
      height: 100% !important;
      width: 100% !important;
    }
  }
`;
